import { useState } from 'react'

const Footer = () => {
    const [email, setEmail] = useState('')
    return (
        <footer className='container pb-20 px-4'>
            <div className='container md:px-0 md:py-12 text-gray-300 text-center  xl:max-w-3/5 text-sm'>
                <div className='flex flex-col md:flex-row space-y-4 md:space-x-12 justify-center items-center py-20'>
                    <div className='text-gray-100 flex w-full justify-center space-x-6 md:basis-3/6 mx-auto'>
                        <div className=''>
                            <a
                                href='https://twitter.com/nisamerica'
                                target='_blank'
                                rel='noreferrer'
                                data-label='Twitter'
                            >
                                <i className='fab fa-twitter fa-2x md:fa-5x btn'></i>
                            </a>
                        </div>
                        <div>
                            <a
                                href='https://www.facebook.com/NISAmericaInc/'
                                target='_blank'
                                rel='noreferrer'
                                className=''
                                data-label='Facebook'
                            >
                                <i className='fab fa-facebook-f fa-2x btn'></i>
                            </a>
                        </div>
                        <div>
                            <a
                                href='https://www.instagram.com/nisamerica/'
                                target='_blank'
                                rel='noreferrer'
                                className=''
                                data-label='Instagram'
                            >
                                <i className='fab fa-instagram fa-2x btn'></i>
                            </a>
                        </div>
                        <div>
                            <a
                                href='https://www.youtube.com/user/NISAmerica'
                                target='_blank'
                                rel='noreferrer'
                                className=''
                                data-label='YouTube'
                            >
                                <i className='fab fa-youtube fa-2x btn'></i>
                            </a>
                        </div>
                        <div>
                            <a
                                href='https://www.twitch.tv/nisamerica'
                                target='_blank'
                                rel='noreferrer'
                                className=''
                                data-label='Twitch'
                            >
                                <i className='fab fa-twitch fa-2x btn'></i>
                            </a>
                        </div>
                        <div>
                            <a
                                href='https://discord.gg/nisa'
                                target='_blank'
                                rel='noreferrer'
                                className=''
                                data-label='Discord'
                            >
                                <i className='fab fa-discord fa-2x btn'></i>
                            </a>
                        </div>
                    </div>
                    <div className='mailchimp md:basis-3/6'>
                        <form
                            action='https://nisamerica.us11.list-manage.com/subscribe/post?u=e8fc423eff95099d1ffcc6009&amp;id=349f7d20f9'
                            method='post'
                            id='mc-embedded-subscribe-form'
                            name='mc-embedded-subscribe-form'
                            className='validate'
                            target='_blank'
                            noValidate=''
                        >
                            <div id='mc_embed_signup_scroll' className='mailchimp text-center'>
                                <div>
                                    <label htmlFor='mce-EMAIL' className='subscribe text-sm'>
                                        Subscribe to our mailing list to get the latest information!
                                    </label>
                                </div>

                                <div className='flex max-w-[500px] mx-auto items-stretch my-8 justify-center border-0 border-gray-800'>
                                    <input
                                        className='bg-gray-100 text-sm w-full  text-gray-800 px-4 py-2 border focus:outline-none focus:border-poegold'
                                        type='email'
                                        placeholder='Your Email'
                                        value={email}
                                        name='b_e8fc423eff95099d1ffcc6009_349f7d20f9'
                                        onChange={(e) => setEmail(e.target.value)}
                                    />
                                    <button className='bg-stone-800 text-sm tracking-wider text-white px-2 md:px-8 py-2 uppercase'>
                                        subscribe
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div className='flex flex-row md:flex-nowrap flex-wrap space-y-3 md:space-y-0 space-x-0 md:space-x-1 justify-center items-center max-w-[1000px] mx-auto'>
                    <div className='basis-1/3 md:basis-2/5'>
                        <img
                            className='mx-auto'
                            src={`${process.env.PUBLIC_URL}/assets/rtt2.svg`}
                            alt='esrb rp-e10'
                        />
                    </div>
                    <div className='basis-1/3 md:basis-1/5'>
                        <img
                            className='mx-auto w-3/5'
                            src={`${process.env.PUBLIC_URL}/assets/pcgame.webp`}
                            alt='esrb rp-e10'
                        />
                    </div>
                    <div className='w-full md:hidden'></div>
                    <div className='w-full basis-2/3 md:basis-3/5'>
                        <img
                            className='w-full mx-auto'
                            src={`${process.env.PUBLIC_URL}/assets/ps45.webp`}
                            alt='play station45'
                        />
                    </div>{' '}
                    <div className='basis-1/3 md:basis-2/5 w-full'>
                        <img
                            className='w-full mx-auto'
                            src={`${process.env.PUBLIC_URL}/assets/nsw-horizontal.webp`}
                            alt='play station4'
                        />
                    </div>{' '}
                    
                </div>
                <div className='flex flex-row justify-center items-center mt-8 max-w-[900px] mx-auto'>
                    {' '}
                    <div className='w-full basis-1/2 md:basis-1/6'>
                        <img
                            className='w-full mx-auto'
                            src={`${process.env.PUBLIC_URL}/assets/granzella.webp`}
                            alt='nisj'
                        />
                    </div>
                    <div className='w-full basis-1/2 md:basis-1/6 '>
                        <img className='mx-auto w-full' src={`${process.env.PUBLIC_URL}/assets/nis.webp`} alt='nis' />
                    </div>
                </div>

                <div className='py-28'>
                    <div className='text-sm text-white border-t-0 border-stone-700'>
                        <p className='pt-20'>
                            ©Granzella Inc. "R-TYPE" is a trademark and/or copyright of IREM SOFTWARE ENGINEERING INC.
                            Licensed to and published by NIS America, Inc.
                        </p>
                        <p>
                            ©2022 Sony Interactive Entertainment LLC. "<span className='font-sie'>1</span>",
                            "PlayStation", "<span className='font-sie'>5</span>", "PS5”, "
                            <span className='font-sie'>4</span>", "PS4", "<span className='font-sie'>0</span>" and "Play
                            Has No Limits" are registered trademarks or trademarks of Sony Interactive Entertainment
                            Inc.
                        </p>{' '}
                        <p>Nintendo Switch is a trademark of Nintendo.</p>{' '}
                      
                        <p>
                            The rating icon is a trademark of the Entertainment Software Association. All other
                            trademarks are properties of their respective owners.
                        </p>
                    </div>{' '}
                </div>
            </div>
        </footer>
    )
}

export default Footer
